import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Page, Section, Site } from '../../editor-container/editor-model';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { takeUntil } from 'rxjs/operators';
import { RenderedSection, SectionEditorBridgeService } from '../../services/section-editor-bridge.service';
import { SectionsEditorService } from './sections-editor.service';

@Component({
  selector: 'kve-sections-editor',
  templateUrl: './sections-editor.component.html',
  styleUrls: ['./sections-editor.component.scss']
})
/**
 * Class list sections of a selected page
 * Members/Fields
 * 1. siteConfigSubscription subscribes to the PreviewEditStore Service
 * 2. renderedSectionsSubscription subscribes to the SectionEditorBridgeService
 * 3. selectedPage: The Page selected for editing
 * 4. selectedSite: The Site selected for editing (MultiSite Mode)
 * 5. sections: Array of objects based on the Section interface
 * 6. renderedSections: Array of type RenderedSection
 * 7. selectedSection: Section selected for editing
 * 8. selectedRenderedSection: Object of type RenderedSection
 * 9. selectedSite$
 *
 * Services
 * 1. PreviewEditStoreService - ComponentStore for state management
 * 2. SectionEditorBridgeService -
 * 3. SectionsEditorService
 *
 */
export class SectionsEditorComponent implements OnInit {
  siteConfigSubscription: Subscription;
  renderedSectionsSubscription: Subscription;
  selectedPage: Page;
  selectedSite: Site;
  sections: Section[];
  renderedSections: RenderedSection[] = [];
  selectedSection: Section;
  selectedRenderedSection: RenderedSection;
  listMode = true;

  selectedSite$: Subscription;

  private destroy$: Subject<void> = new Subject<void>();
  constructor(
    private previewEditStoreService: PreviewEditStoreService,
    private sectionEditorBridgeService: SectionEditorBridgeService,
    private sectionsEditorService: SectionsEditorService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.siteConfigSubscription = this.previewEditStoreService.siteEditorSitesState$.pipe(takeUntil(this.destroy$)).subscribe(siteEditorSitesState => {
      if (siteEditorSitesState != undefined) {
        console.log(siteEditorSitesState);
        if (siteEditorSitesState != null && siteEditorSitesState != undefined) {
          console.log(siteEditorSitesState);
          this.previewEditStoreService.selectedSite$.subscribe((site: Site) => {
            if (site != undefined) {
              this.selectedSite = site;
            } else {
              this.selectedSite = siteEditorSitesState[0];
            }
            this.previewEditStoreService.selectedPageType$.subscribe(pageType => {
              // console.log(pageType);
              if (pageType != null && pageType != undefined) {
                if (this.selectedSite != undefined) {
                  if (this.selectedSite.pages != undefined) {
                    this.selectedSite.pages.forEach(page => {
                      if (page.pageType == pageType) {
                        this.selectedPage = page;
                        this.sections = this.selectedPage.sections;
                        // console.log(this.sections);
                      }
                    })
                  }
                }
              }
            })
          })
          // let selectedPageType = this.resolvePage(this.selectedSite,this.selectedPageType$)

        }
      }

    });
    this.renderedSectionsSubscription = this.sectionEditorBridgeService.getSectionElements().pipe(takeUntil(this.destroy$)).subscribe(renderedSections => {
      if (renderedSections != null && renderedSections != undefined) {
        // console.log(renderedSections);
        this.renderedSections = renderedSections;
      }
    })
    this.selectedSite$ = this.previewEditStoreService.selectedSite$.pipe(takeUntil(this.destroy$)).subscribe((site: Site) => {
      console.log(site);
      if (site != null && site != undefined) {
        this.selectedSite = site;
        this.previewEditStoreService.selectedPageType$.subscribe(pageType => {
          console.log(pageType);
          if (pageType != null && pageType != undefined) {
            if (this.selectedSite != undefined) {
              if (this.selectedSite.pages != undefined) {
                this.selectedSite.pages.forEach(page => {
                  if (page.pageType == pageType) {
                    this.selectedPage = page;
                    this.sections = this.selectedPage.sections;
                    this.cdr.detectChanges();
                    /* this.previewEditStoreService.selectedSection$.subscribe(section => {
                      this.selectedSection = section;
                    }) */
                  }
                })
              }
            }
          }
        })
      }

    })
  }
  /**
   * Function is triggred from an event in a child component (section-navigator.component.ts)
   * @param sectionId Id of the section selected for editing
   * Sets the selectedSection and the selectedRenderedSection based on the sectionId
   */
  editSection(sectionId: string): void {
    // console.log(`Sections - Track Selected Section: ${sectionId}`)
    this.listMode = false;
    this.selectedSection = this.sections.find(section => section.sectionId == sectionId);
    if (this.selectedSection != undefined && this.selectedSection != null) {
      this.previewEditStoreService.updateSelectedSection(this.selectedSection);
      this.selectedRenderedSection = this.renderedSections.find(renderedSection => renderedSection.sectionId == sectionId);
    }

    console.log(this.selectedSection)
    // console.log(this.selectedRenderedSection)
  }

  toggleListMode(e) {
    this.listMode = !this.listMode;
  }

  toggleSelection(sectionId: string) {
    this.sectionsEditorService.setSelectedId(sectionId);
  }

}
